import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=2408cabe&"
import script from "./comment-item.vue?vue&type=script&lang=ts&"
export * from "./comment-item.vue?vue&type=script&lang=ts&"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=2408cabe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports